import { useMutation } from '@apollo/react-hooks';
import { CartIdContext } from '@jetshop/core/components/Cart/CartIdContext';
import { addToCartSuccess } from '@jetshop/core/components/Mutation/AddToCart/addToCartUtils';
import t from '@jetshop/intl';
import ProductLink from '@jetshop/ui/ProductLink';
import React, { useContext } from 'react';
import styled, { css } from 'react-emotion';
import { addToCart } from '../Cart/addToCart.gql';
import { OnAddToCart } from '../ProductPage/AddToCart/AddToCartForm';
import { theme } from '../Theme';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEnvelope,
  faShoppingCart,
  faTags,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(faShoppingCart, faTags, faEnvelope);

const buttonStyle = css`
  background: ${theme.colors.buy};
  text-transform: uppercase;
  font-family: 'Abel', sans-serif;
  font-size: 1.3rem;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
  color: white;
  padding: 0.5rem 1rem;
`;

const colorStyle = css`
  color: ${theme.colors.green} !important;
  &:hover {
    background: ${theme.colors.green} !important;
    color: #fff !important;

    svg {
      color: #fff;
    }
  }
`;

const StyledProductLink = styled(ProductLink)`
    color: ${theme.colors.green} !important;

    &[data-not-buyable='true'] {
        color: ${theme.colors.blue} !important
    }
    
    &:hover {
        background: ${theme.colors.green} !important;

        &[data-not-buyable='true'] {
            background: ${theme.colors.blue} !important
        }

        svg {
            color: #fff;
        }
    }
`;

function QuickBuyButton({ product, productListView }) {
  const { cartId, setCartId } = useContext(CartIdContext);
  const { hasVariants, stockStatus, articleNumber } = product;
  const [add] = useMutation(addToCart, {
    variables: {
      input: {
        cartId,
        articleNumber,
        quantity: 1,
      },
    },
    onCompleted: (data) => addToCartSuccess({ cartId, setCartId })({ data }),
  });

  if (hasVariants || !stockStatus?.buyable) {
    return (
      <StyledProductLink
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'inherit',
        }}
        product={product}
        data-not-buyable={!stockStatus?.buyable}
      >
        {productListView ? (
          <span className={buttonStyle}>{t('Lägg i varukorgen')}</span>
        ) : stockStatus?.buyable ? (
          <FontAwesomeIcon icon={['fa', 'tags']} />
        ) : (
          <FontAwesomeIcon icon={['fa', 'envelope']} />
        )}
      </StyledProductLink>
    );
  }

  return (
    <OnAddToCart onClick={add}>
      {(props) => (
        <button
          className={colorStyle}
          onClick={() => {
            add();
            props.showTarget(true);
          }}
        >
          {productListView ? (
            <span className={buttonStyle}>{t('Lägg i varukorgen')}</span>
          ) : (
            <FontAwesomeIcon icon={['fal', 'shopping-cart']} />
          )}
        </button>
      )}
    </OnAddToCart>
  );
}

export { QuickBuyButton };
